import React from 'react';
import { StarIcon, MessageCircleIcon } from 'lucide-react';
const Testimonials: React.FC = () => {
  const testimonials = [{
    quote: 'Jag har alltid haft problem med erektionen. Jag trodde alltid att det var något i mitt huvud. Jag sökte psykologer, terapeuter och till och med läkare som behandlar manlig hälsa. Bara VeeloBooster kunde lösa mitt problem! Det förbättrade mitt sexliv markant, förbättrade min sexdrift och gav mig starka och långvariga erektioner! VeeloBooster är på riktigt!',
    author: 'Elias Burström, 22, Eslöv',
    title: 'Styva och starka erektioner äntligen'
  }, {
    quote: 'Jag var trött på att ha samma ursäkter ", Jag, är, inte, på, humör, ", ": huvudvärk, ",etc… Så jag provade VeeloBooster! Den där monotonin och det låga intresset av sex var som bortblåsat! Nu har jag sex med min fru varje dag och önskar mig mer! VeeloBooster, min fru ville bar säga ": Tack!, "',
    author: 'Roland Lindström, 26, Sundsvall',
    title: 'Min fru säger tack'
  }, {
    quote: 'En av mina vänner berättade om VeeloBooster och att jag måsta prova det. Sagt och gjort! VeeloBooster gav mig den virilitet jag alltid drömt om att ha i sängen. Följ bara instruktionerna och märk resultaten själv!',
    author: 'Markus Olsson, 42, Rättvik',
    title: 'Svaga erektioner? Inte nu längre!'
  }, {
    quote: 'Alltid när jag anförtrodde mig till mina vänner var oron den samma ", Om, jag, får, med, en, kvinna, hem, går, det, aldrig, som, det, ska, ., " Idag dock så har VeeloBooster givit mig den push jag behövde för att få kraftfulla erektioner',
    author: 'Emil Sundström, 31, Funäsdalen',
    title: 'Erektioner utan oro'
  }];
  return <section className="w-full py-16 px-4 bg-[#0A1020]" data-id="element-349">
      <div className="max-w-5xl mx-auto" data-id="element-350">
        <div className="text-center mb-12" data-id="element-351">
          <h2 className="text-3xl font-bold mb-4" data-id="element-352">
            BLI EN AV DE MÅNGA MÄN SOM KÄNNER TILL VeeloBooster
          </h2>
          <p className="text-gray-300" data-id="element-353">
            Se några av de tusentals framgångsberättelser vi tar emot dagligen.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-354">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-gray-900 p-6 rounded-lg" data-id="element-355">
              <div className="flex items-center mb-4" data-id="element-356">
                <MessageCircleIcon className="w-5 h-5 text-[#0EB7FF] mr-2" data-id="element-357" />
                <h3 className="font-semibold text-lg" data-id="element-358">{testimonial.title}</h3>
              </div>
              <div className="flex text-yellow-400 mb-4" data-id="element-359">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-360" />)}
              </div>
              <p className="text-gray-300 mb-4 italic" data-id="element-361">"{testimonial.quote}"</p>
              <p className="text-sm text-gray-400" data-id="element-362">{testimonial.author}</p>
            </div>)}
        </div>
      </div>
    </section>;
};
export default Testimonials;